import * as React from 'react'
import {Link, useNavigate} from 'react-router-dom'

import styled from 'styled-components/macro'
import Logo from 'assets/images/Logo1.svg'
import ServicesDropdown from 'common/ServicesDropdown'
import MobileMenu from 'common/MobileMenu'
import {QUERIES} from './constants'

const Wrapper = styled.div`
  width: 100%;
  color: white;
  /* @media ${QUERIES.tabletAndUp} {
    display: flex;
    justify-content: center;
  } */
  z-index: 2;
`

const StyledLogo = styled.img`
  height: 63px;
`

const Banner = styled.header`
  display: none;
  padding: 24px;
  font-family: Mulish;
  font-size: calc(24 / 16 * 1rem);

  justify-content: space-between;
  align-items: center;
  background-color: var(--darker-grey);
  color: var(--white);
  width: 100%;
  @media ${QUERIES.tabletAndUp} {
    display: flex;
  }
`

const Links = styled.div`
  color: white;
  display: flex;
  gap: 16px;
  margin-right: 24px;
`

const StyledLink = styled(Link)`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  font-size: calc(16 / 16 * 1rem);
  font-weight: 300;
  font-family: 'Rubik';
  text-transform: uppercase;
  font-style: italic;
  text-decoration: none;
  width: 119px;
  height: 71px;
  border-radius: 5px;
  transition: all 0.3s ease-in-out;
  :hover {
    background-color: var(--dark-grey);
  }
`

const StyledServicesLink = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  color: var(--white);
  font-size: calc(16 / 16 * 1rem);
  font-weight: 300;
  font-family: 'Rubik';
  text-transform: uppercase;
  font-style: italic;
  text-decoration: none;
  width: 119px;
  height: 71px;
  border-radius: 5px;
  transition: all 0.3s ease-in-out;
  cursor: pointer;
  position: relative;
  :hover {
    background-color: var(--dark-grey);
  }
  background-color: ${p =>
    p.active === 'true' ? 'var(--dark-grey)' : 'intial'};
`

const HeaderBar = () => {
  const navigate = useNavigate()
  const [showServices, setShowServices] = React.useState(false)
  const toggleServicesDropdown = () => {
    setShowServices(!showServices)
  }

  return (
    <Wrapper>
      <Banner>
        <StyledLogo src={Logo} onClick={() => navigate('/')} />
        <Links>
          <StyledLink to="/">Home</StyledLink>
          <StyledServicesLink
            onClick={toggleServicesDropdown}
            active={String(showServices)}
          >
            Services <ServicesDropdown visible={showServices} />
          </StyledServicesLink>
          <StyledLink to="/shop">Shop</StyledLink>
          <StyledLink to="/about">About</StyledLink>
          <StyledLink to="/contact">Contact</StyledLink>
        </Links>
      </Banner>
      <MobileMenu />
    </Wrapper>
  )
}
export default HeaderBar
